import { useAppContext } from '../../context/AppContext';
import { useCmsText } from '../../hooks/useCmsText';

interface CheckMessageButtonProps {
  handleCheck: () => void;
}

const CheckMessageButton = ({ handleCheck }: CheckMessageButtonProps) => {
  const { state } = useAppContext();
  const { renderPlainText: renderText } = useCmsText();

  return (
    <button
      disabled={!state.termCheck || !state.selectedSourceType || !state.copiedText}
      onClick={handleCheck}
      className={`bg-primary px-5 py-4 rounded-xl flex flex-row items-center justify-center mt-10 ${
        (!state.termCheck || !state.selectedSourceType || !state.copiedText) 
          ? 'opacity-50 cursor-not-allowed' 
          : ''
      }`}
      style={{ 
        pointerEvents: (!state.termCheck || !state.selectedSourceType || !state.copiedText) 
          ? 'none' 
          : 'auto', 
        background: state.branding?.mainButtonBackground,
        font: `${state.branding?.mainButtonFont} !important`,
      }}
    >
      <h1 className="text-sm font-semibold text-white">{renderText('origin_button_check', 'Sjekk melding')}</h1>
      {/* <BsArrowRight size={'1.2em'} className="text-white ml-2" /> */}
      {/* <i className="lni lni-arrow-right text-white"></i> */}
    </button>
  );
};

export default CheckMessageButton;